import type { Match, SourceId } from "@/app/(app)/screening/_data/types";

// Daily screening requests for the last 30 days, oldest → newest.
export const SCREENING_REQUESTS_30D = [
  4, 3, 5, 2, 5, 6, 3, 4, 7, 5, 6, 8, 4, 5, 3, 6, 5, 7, 9, 6, 8, 12, 7, 5, 4, 6, 9, 7, 5, 8,
];

// Monthly screening requests for the last 12 months, oldest → newest.
export const SCREENING_REQUESTS_12M = [16, 22, 19, 25, 21, 18, 24, 33, 38, 45, 52, 65];

// Daily new matches against monitored names (last 30 days).
export const MONITORING_NEW_MATCHES_30D = [
  0, 1, 0, 2, 0, 0, 1, 3, 2, 0, 1, 0, 4, 1, 2, 0, 1, 3, 2, 1, 5, 2, 1, 0, 3, 1, 2, 1, 0, 2,
];

// Daily count of "matched names" (monitored names with at least 1 active match).
export const MONITORING_MATCHED_NAMES_30D = [
  3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8,
];

// Monthly new matches against monitored names (last 12 months).
export const MONITORING_NEW_MATCHES_12M = [4, 6, 5, 8, 7, 9, 11, 14, 12, 18, 22, 27];

// Monthly average count of "matched names" (last 12 months).
export const MONITORING_MATCHED_NAMES_12M = [1, 1, 2, 2, 2, 3, 4, 4, 5, 6, 7, 8];

export const SEEN_BUCKETS = ["4m ago", "22m ago", "1h ago", "2h ago", "3h ago", "5h ago"];

export const ALERT_TIME_BUCKETS = ["Just now", "4h ago", "Yesterday", "2d ago", "3d ago"];

export type ScreeningRun = {
  /** React-key-safe row identifier — synthesized when the backend gave no usable id, so NOT safe as an export/report key. */
  id: string;
  /** The real search-query UUID, if the backend gave one — undefined (never synthesized) when it didn't, so callers can tell "no exportable id" from "has one". */
  searchId?: string;
  query: string;
  /** Passport / national ID / tax ID used as a search identifier, if any. */
  identifier?: string;
  countryIso: string | null;
  /** All ISO-2 country codes used as filters for this screening. */
  countries?: string[];
  /** Matching-score threshold (0–1) the user set when running this screening. */
  minScore: number;
  topSource: SourceId | null;
  hits: number;
  seen: string;
  /** ISO timestamp of when the search was run — used by the historical screening view. */
  runAt: string;
  /** Entity type filter used in the original search (UI vocab: Individual, Organization…). */
  entityType?: string | null;
  /** Date of birth filter used in the original search (YYYY-MM-DD). */
  dob?: string;
  /** Picker selection ids (coll:xxx or source ids) for the watchlists used. */
  watchlists?: string[];
  /** Source short_name values used for this screening (for the source-list chip). */
  sourceIds?: string[];
  /** Pre-adapted matches from the /search/latests/ response, if present. */
  results?: Match[];
};
